import React from "react";
import {
  getTranscriptBubbleStyle,
  TRANSCRIPT_BUBBLE_SPEAKER_STYLE,
  TRANSCRIPT_BUBBLE_TEXT_STYLE,
} from "../utils/transcriptMessageStyles";

const TranscriptMessageBubble = ({
  role,
  message,
  style,
  textStyle,
  speakerStyle,
}) => (
  <div style={{ ...getTranscriptBubbleStyle(role), ...style }}>
    <div style={{ ...TRANSCRIPT_BUBBLE_SPEAKER_STYLE, ...speakerStyle }}>
      {role || "Caller"}
    </div>
    <span style={{ ...TRANSCRIPT_BUBBLE_TEXT_STYLE, whiteSpace: "pre-wrap", ...textStyle }}>
      {message || "--"}
    </span>
  </div>
);

export default TranscriptMessageBubble;
